// extracted by css-extract-rspack-plugin
export default {"actionMenuButton":"GlobalCreateMenu-module__actionMenuButton__Hj_iB"};